import { useSyncExternalStore } from "react";
import { useLocation } from "react-router-dom";
import { getMarketingLanguageFromPath, MARKETING_LOCALES } from "../../../marketing-content/marketingLocales";
import { buildAppUrl } from "./appHandoff";
import { AppStore, buildAppStoreUrl } from "./appStoreRoute";

const subscribeToNothing = () => () => {};

/**
 * False during the build-time rendering of the marketing pages and during React's first render in the
 * browser when it adopts (hydrates) that rendering; true from the render right after. Anything read from
 * the visitor's browser must wait for it, or the two renders differ and React discards the static page.
 */
export function useIsHydrated(): boolean {
  return useSyncExternalStore(
    subscribeToNothing,
    () => true,
    () => false
  );
}

/** `buildAppUrl` for an href rendered on the page: the visitor's own params are added once React has hydrated. */
export function useAppUrl(appPath: string, extraParams: Record<string, string> = {}): string {
  const isHydrated = useIsHydrated();
  const { pathname } = useLocation();
  const localeHint = MARKETING_LOCALES[getMarketingLanguageFromPath(pathname)].productLocale;
  return buildAppUrl(appPath, extraParams, { withVisitorParams: isHydrated, localeHint });
}

/** `buildAppStoreUrl` for an href rendered on the page: without the visitor's params until React has hydrated. */
export function useAppStoreUrl(store: AppStore): string {
  const isHydrated = useIsHydrated();
  return buildAppStoreUrl(store, { withVisitorParams: isHydrated });
}
